module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo_one2x.49302e06.png";